import i18n from './i18n'

export { LocaleCode } from './LocaleCode'
export { i18n }
